import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { request, reportErrorToHoneybadger } from '../helpers/Requests'

import SetTitle from '../components/shared/SetTitle';
import HelpText from '../components/help/HelpText';

import { adminUser, managerUser, setIdAndMethod, renderErrorWarning, renderErrors } from '../utilities/Forms.js'
import { formatDate } from '../utilities/Generic.js'

import Audits from '../components/shared/Audits';

class SicknessForm extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  state = {
    name: "",
    start_time: formatDate(new Date(), 0) + "T00:00",
    end_time: formatDate(new Date(), -1) + "T00:00",
    reason: "",
    doctor_note_provided: false,

    loaded: false,
    unauthorized: "",
    errors: "",
    error: ""
  };

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});
  }

  handleCheckbox(event) {
    const name = event.target.name;
    const value = event.target.checked;

    this.setState({[name]: value});
  }

  handleSubmit(event) {
    this.setState({ updating: true })

    var json = JSON.stringify({
      "staff_sickness": {
        "person_id": this.props.person_id,
        "start_time": this.state.start_time,
        "end_time": this.state.end_time,
        "reason": this.state.reason,
        "doctor_note_provided": this.state.doctor_note_provided
      }
    })

    const [id, method] = setIdAndMethod(this.props.mode, this.props.id)

    request(method, `/v1/a/staff_sicknesses/${id}`, json, () => {this.setState({ unauthorized: true })})
      .then(data => {
        sessionStorage.setItem("updateSuccess", `Sickness ${this.props.mode}d successfully!`);

        this.props.closePanel()
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ updating: false, error: error })
        }
        else {
          this.setState({ updating: false, errors: error })
        }
      })

    event.preventDefault();
  }

  handleDelete(event) {
    this.setState({ updating: true })

    request("DELETE", `/v1/a/staff_sicknesses/${this.props.id}`, "", () => {this.setState({ unauthorized: true })})
      .then(data => {
        sessionStorage.setItem("updateSuccess", `Sickness deleted successfully!`);

        this.props.closePanel()
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ updating: false, error: error })
        }
        else {
          this.setState({ updating: false, errors: error })
        }
      })

    event.preventDefault();
  }

  renderSaveButton() {
    if (adminUser() || managerUser()) {
      return <input type="submit" value="Save" disabled={this.state.updating} />
    }
    else {
      return <input type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  renderDeleteButton() {
    if (adminUser() || managerUser()) {
      return <div className="button float-right red-button" onClick={this.handleDelete}>Delete</div>
    }
  }

  render() {
    const { name, start_time, end_time, reason, doctor_note_provided, loaded, id, redirect, unauthorized, errors, error } = this.state;

    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (redirect && id) {
      return <Redirect to={`/people/${this.props.person_id}`}/>
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    const title = this.props.mode === "create" ? "New" : "Edit"
    const formatName = name ? ` ${name} |` : ""

    return (
      <div>
        <SetTitle title={`${title} Sickness |${formatName} Sicknesses`} />

        <form onSubmit={this.handleSubmit}>
          <div className="settings big-settings">
            { renderErrors(errors, 'person') }

            <div className="row">
              <label className="column">Start Date:</label>{ renderErrors(errors, 'start_time') }
              <HelpText className="inline" page={'staff_sicknesses'} section={'start_time'} />

              <input type="datetime-local" name="start_time" onChange={this.handleChange} value={start_time} />
            </div>
            <div className="row">
              <label className="column">End Date:</label>{ renderErrors(errors, 'end_time') }
              <HelpText className="inline" page={'staff_sicknesses'} section={'end_time'} />

              <input type="datetime-local" name="end_time" onChange={this.handleChange} value={end_time} />
            </div>

            <div className="row small-bottom-margin">
              <label className="column">Reason:</label>{ renderErrors(errors, 'reason') }
              <HelpText className="inline" page={'staff_sicknesses'} section={'reason'} />

              <textarea name="reason" onChange={this.handleChange} value={reason} />
            </div>

            <div className="row">
              <HelpText page={'staff_sicknesses'} section={'doctor_note_provided'} />

              <input className="column small-bottom-margin" type="checkbox" name="doctor_note_provided" checked={doctor_note_provided} onChange={this.handleCheckbox} />
              <label className="column checkbox-label" htmlFor="critical">Doctor's note received?</label>
            </div>
          </div>

          <div className="settings big-settings">
            { this.renderSaveButton() }
            { this.renderDeleteButton() }
            { renderErrorWarning(errors) }
          </div>
        </form>

        { this.props.mode === "update" && <Audits klass="StaffSickness" id={this.props.id} /> }
      </div>
    );
  }

  componentDidMount() {
    let id = this.props.id;

    if (this.props.mode === "update") {
      request('GET', `/v1/a/staff_sicknesses/${id}`, null, () => {this.setState({ unauthorized: true })})
        .then(data => {
          this.setState({
            start_time: data.start_time,
            end_time: data.end_time,
            reason: data.reason,
            doctor_note_provided: data.doctor_note_provided,
            loaded: true
          })
        })
        .catch(error => {
          reportErrorToHoneybadger(error)

          this.setState({ error, loaded: true })
        })
    }
    else {
      this.setState({ loaded: true })
    }
  }
}

export default SicknessForm;
